export default "__VITE_ASSET__3F5ID6aw__"